export interface TrainingSection {
    id: number;
    season_id: number;
    name: string;
    order: number;
    collapsed: boolean;
    created_by: number;
    created_at: string;
    changed_by: number;
    changed_at: string;
}

export const emptyTrainingSection: TrainingSection = {
    id: 0,
    season_id: 0,
    name: '',
    order: 0,
    collapsed: false,
    created_by: 0,
    created_at: '',
    changed_by: 0,
    changed_at: ''
}
